import React from 'react';
import styles from './ToggleSwitch.module.scss';
import cn from 'classnames';
import PropsTypes from 'prop-types';

const ToggleSwitch = ({isToggled, handleToggle, label, id, disabled}) => {

  const handleClick = () => {
      handleToggle(!isToggled);
  };

  return (
    <div className={cn('d-flex flex-column align-items-center justify-content-center px-2',styles.switchContainer, window.innerWidth < 1000 ? 'fs-14': 'fs-10')}>
      <input
        type="checkbox"
        id={id}
        checked={isToggled}
        onChange={handleClick}
        className={styles.switchInput}
        disabled={disabled}
      />
      <label htmlFor={id} className={styles.switchLabel}>
        <span className={styles.switchButton} style={{backgroundColor: isToggled ? (disabled ? 'gray' : '#18BD63') : '#fff'}}>
           {isToggled && (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styles.tickIcon}>
                <path d="M9 16.17L5.53 12.7a.996.996 0 1 1 1.41-1.41l2.47 2.47 6.36-6.36a.996.996 0 1 1 1.41 1.41L9 16.17z" />
                </svg>
            )}  
        </span>
      </label>
      <span className='fw-600'>{label}</span>
    </div>
  );
};

ToggleSwitch.propTypes = {
    id: PropsTypes.string.isRequired,
    isToggled:PropsTypes.bool.isRequired,
    handleToggle: PropsTypes.func.isRequired
}

export default ToggleSwitch;